<div class="nav-card pointer">
	{{ name }}
</div>
